export default __webpack_public_path__ + "static/media/ChooseMateri.48c78b47.png";